"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const modConfigEntriesQueryKey = function () {
  let {
    configName,
    moduleName,
    namespaceAppend
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const namespace = ['stripes-kint-components', 'modConfigSettings', moduleName, configName];
  if (Array.isArray(namespaceAppend)) {
    namespaceAppend.forEach(appendItem => {
      namespace.push(appendItem);
    });
  } else if (namespaceAppend) {
    namespace.push(namespaceAppend);
  }
  return namespace;
};
var _default = exports.default = modConfigEntriesQueryKey;